var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSuccessImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_474_432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 118
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_474_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1649 67.8502L40.6242 57.2793C39.7254 56.3779 38.5815 55.9272 37.1924 55.9272C35.8033 55.9272 34.6593 56.3779 33.7605 57.2793C32.8617 58.1807 32.4123 59.3279 32.4123 60.721C32.4123 62.1141 32.8617 63.2613 33.7605 64.1627L47.7331 78.1752C48.7136 79.1585 49.8576 79.6502 51.1649 79.6502C52.4723 79.6502 53.6163 79.1585 54.5968 78.1752L82.2968 50.396C83.1957 49.4946 83.6451 48.3474 83.6451 46.9543C83.6451 45.5613 83.1957 44.4141 82.2968 43.5127C81.398 42.6113 80.2541 42.1606 78.865 42.1606C77.4759 42.1606 76.3319 42.6113 75.4331 43.5127L51.1649 67.8502ZM58.0287 108.167C51.2467 108.167 44.8732 106.876 38.9083 104.295C32.9434 101.714 27.7547 98.2106 23.3424 93.7856C18.93 89.3606 15.4368 84.1571 12.8629 78.1752C10.289 72.1932 9.00208 65.8016 9.00208 59.0002C9.00208 52.1988 10.289 45.8071 12.8629 39.8252C15.4368 33.8432 18.93 28.6397 23.3424 24.2147C27.7547 19.7897 32.9434 16.2866 38.9083 13.7054C44.8732 11.1241 51.2467 9.8335 58.0287 9.8335C64.8107 9.8335 71.1841 11.1241 77.149 13.7054C83.1139 16.2866 88.3026 19.7897 92.715 24.2147C97.1274 28.6397 100.621 33.8432 103.194 39.8252C105.768 45.8071 107.055 52.1988 107.055 59.0002C107.055 65.8016 105.768 72.1932 103.194 78.1752C100.621 84.1571 97.1274 89.3606 92.715 93.7856C88.3026 98.2106 83.1139 101.714 77.149 104.295C71.1841 106.876 64.8107 108.167 58.0287 108.167Z",
    fill: "url(#paint0_linear_474_432)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_474_432",
    x1: 39.0466,
    y1: 40.0092,
    x2: 80.4866,
    y2: 179.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854515,
    stopColor: "#91C153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccessImg);
export default __webpack_public_path__ + "static/media/modal-success-img.c83fa61e077ee97cb8483c9568298998.svg";
export { ForwardRef as ReactComponent };